import React, { useState, useRef, useEffect } from "react";

import { endPoints } from "../../../constant/Environment";
import { addData, getAllData, getAllFilterData } from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import SearchIcon from "@mui/icons-material/Search";
import { Col, Row, Container } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import successicon from "../../../assests/payments_icon/success.png";
import pendingicon from "../../../assests/payments_icon/pending.png";
import canceicon from "../../../assests/payments_icon/cancel.png";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const RedemDetails = (props) => {
  const { selectedRecord } = props;
  // const location = useLocation();
  // const { user_id } = location.state || {};
  // console.log("user_id", user_id);
  const [viewShow, setViewShow] = useState(false);
  const [checkShow, setCheckShow] = useState(false);
  const [pauseShow, setPauseShow] = useState(false);
  const [cancelShow, setCancelShow] = useState(false);

  const [editData, setEditData] = useState({});
  const [customerId, setCustomerId] = useState("");
  const [giftItem, setGiftItem] = useState("");
  const [claimDate, setClaimDate] = useState("");
  const [processDate, setProcessDate] = useState("");
  const [trackingCode, setTrackingCode] = useState("");
  const [status, setStatus] = useState(null);
  const [price, setPrice] = useState(null);
  const [giftCopy, setgiftCopy] = useState(null);
  const [termConditions, setTermConditions] = useState(null);

  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [totalcount, setTotalCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [userId, setUserId] = useState("");
  const [statusType, setStatusType] = useState("0");

  const [email, setEmail] = useState("");
  const [username, setuserName] = useState("");
  const [name, setName] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let filterData = {
    userName: username,
    email: email,
    fromDate: "",
    toDate: "",
    sort: "",
    userId: userId,
    status: statusType,
  };
  useEffect(() => {
    redemptionClaimById(selectedRecord.user_id);
  }, [selectedRecord]);

  useEffect(() => {
    // redemptionClaimList(page);
  }, [rowsPerPage]);

  const redemptionClaimList = async (page) => {
    let url = `${endPoints.api.GET_REDEMPTIONCLAIM}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllFilterData(url, filterData)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          let data = response.data;
          setRows(response.data);
          setPending(false);
          const ITEMS_PER_PAGE = rowsPerPage;
          setTotalCount(data[0]?.totalCount);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const approveRedeem = () => {
    let url = editData?.id ? `${endPoints.api.UPDATE_REDEMPTIONCLAIM}` : null;

    let payload = {
      tracking_number: "",
      status: "2",
      processed_date: "",
      giftcopy: "",
      terms_condition: "",
    };

    if (editData?.id) {
      payload.id = editData.id;
    }
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          redemptionClaimById(selectedRecord.user_id);
          console.log(response);
          setCheckShow(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const cancelRedeem = () => {
    let url = editData?.id ? `${endPoints.api.UPDATE_REDEMPTIONCLAIM}` : null;

    let payload = {
      tracking_number: editData?.tracking_number,
      status: "3",
      processed_date: editData?.processed_date,
      giftcopy: editData?.giftcopy,
      terms_condition: editData?.terms_condition,
    };

    if (editData?.id) {
      payload.id = editData.id;
    }
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          redemptionClaimById(selectedRecord.user_id);
          setCancelShow(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  useEffect(() => {
    if (editData) {
      setCustomerId(editData.user_id || "");
      setGiftItem(editData.gift_title || "");
      setClaimDate(
        editData.processed_date
          ? moment(editData.processed_date).format("YYYY-MM-DD")
          : ""
      );
      setProcessDate(
        editData.processed_date
          ? moment.utc(editData.processed_date).format("YYYY-MM-DD")
          : ""
      );
      setTrackingCode(editData.tracking_number || "");
      setStatus(editData.status || "");
      setPrice(editData.sagacoin_price || "");
      setgiftCopy(editData.giftcopy || "");
      setTermConditions(editData.terms_condition || "");
    }
  }, [editData]);

  const redemptionClaimById = async (id, type) => {
    let url = `${endPoints.api.GET_REDEMPTIONCLAIM}/${id}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          let data = response.data;
          setRows(response.data);
          // setPending(false);
          // const ITEMS_PER_PAGE = rowsPerPage;
          // setTotalCount(data[0]?.totalCount);
          //   setEditData(response.data);
          //   type == "view" && setViewShow(true);
          //   type == "approve" && setCheckShow(true);
          //   type == "cancel" && setCancelShow(true);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const StatusTypeList = [
    {
      id: 0,
      name: "All",
    },
    {
      id: 1,
      name: "Pending",
    },
    {
      id: 2,
      name: "Processed",
    },
    {
      id: 3,
      name: "Canceled",
    },
  ];
  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState("");
  const handleFilterStatus = (type) => {
    setFilterValue(type);
    setStatusType(type);
    if (type == "0") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter((item) => {
        return item.status.includes(type);
      });
      setFilteredRows(filteredData);
    }
  };

  const rowsToDisplay =
    filterValue.length > 0 || statusType != 0 ? filteredRows : rows;

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              {/* <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Redemption Claims Details
                  </h3>
                </div>
              </div> */}

              <div style={{}}>
                <Row>
                  {/* <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Button
                        variant="primary"
                        style={{
                          background: "#0D3862",
                          borderRadius: "8px",
                        }}
                        onClick={() => {
                          navigate("/redemptionClaims");
                        }}
                      >
                        Go Back
                      </Button>
                    </Form.Group>
                  </Col> */}
                  <Col>
                    <Form.Group as={Col} controlId="formAccount">
                      <Form.Label className="label">Status</Form.Label>
                      <Form.Select
                        name="platform"
                        value={statusType}
                        onChange={(e) => {
                          handleFilterStatus(e.target.value);
                        }}
                      >
                        {/* <option value="">Select Status</option> */}
                        {StatusTypeList.map((item) => {
                          return <option value={item.id}>{item.name}</option>;
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Customer ID</TableCell>
                            <TableCell align="center">Gift Title</TableCell>
                            <TableCell align="center">Name </TableCell>
                            <TableCell align="center">Email </TableCell>
                            <TableCell align="center">Source</TableCell>
                          
                            <TableCell align="center">
                              Account Status{" "}
                            </TableCell>
                            <TableCell align="center">Request Date </TableCell>
                            <TableCell align="center">Processed Date</TableCell>

                            <TableCell align="center">Status</TableCell>
                            <TableCell align="center">Price</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {/* .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            ) */}
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">
                                  {row.user_id}
                                </TableCell>
                                <TableCell align="center">
                                  {row.gift_title}
                                </TableCell>
                                <TableCell align="center">{row.name}</TableCell>
                                <TableCell align="center">
                                  {row.email}
                                </TableCell>
                                <TableCell align="center">
                                  {row.pin}
                                </TableCell>
                          
                                <TableCell align="center">
                                  {row.accountStatus}
                                </TableCell>
                                <TableCell align="center">
                                  {row.created_on
                                    ? moment.utc(row.created_on).isValid()
                                      ? moment
                                          .utc(row.created_on)
                                          .format("YYYY-MM-DD")
                                      : ""
                                    : ""}
                                </TableCell>

                                <TableCell align="center">
                                  {row.processed_date
                                    ? moment.utc(row.processed_date).isValid()
                                      ? moment
                                          .utc(row.processed_date)
                                          .format("YYYY-MM-DD")
                                      : ""
                                    : ""}
                                </TableCell>
                                {/* <TableCell align="center">
                                {row.tracking_number}
                              </TableCell> */}
                                <TableCell align="center">
                                  {row.status == 2
                                    ? "Processed"
                                    : row.status == 1
                                    ? "Pending"
                                    : row.status == 3
                                    ? " Canceled"
                                    : ""}
                                </TableCell>
                                <TableCell align="center">
                                  ${row.sagacoin_price}
                                </TableCell>

                                <TableCell
                                  align="center"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-evenly",
                                  }}
                                >
                                  <Button
                                    variant="primary"
                                    className="mrglft10"
                                    style={{
                                      background: "#0D3862",
                                      borderRadius: "8px",
                                    }}
                                    onClick={() => {
                                      setViewShow(true);

                                      setEditData(row);
                                    }}
                                  >
                                    View
                                  </Button>
                                  {row.status == 1 ? (
                                    <>
                                      <img
                                        src={successicon}
                                        style={{ height: "30px" }}
                                        onClick={() => {
                                          // setShow(true);
                                          setCheckShow(true);
                                          setEditData(row);
                                          // redemptionClaimById(row, "approve");
                                        }}
                                      />

                                      <img
                                        src={canceicon}
                                        style={{ height: "30px" }}
                                        onClick={() => {
                                          setCancelShow(true);
                                          setEditData(row);
                                        }}
                                      />
                                    </>
                                  ) : null}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    {/* // use for the approve  */}
                    <Modal
                      show={show}
                      onHide={handleClose}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Manage Redemption Claims:</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group className="mb-3" controlId="giftItem">
                              <Form.Label>Gift Title </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Gift Title "
                                value={giftItem}
                                onChange={(event) => {
                                  setGiftItem(event.target.value);
                                }}
                                disabled
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-6"></div>
                          <div className="col-md-6">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Price</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder=" Enter Price"
                                value={price}
                                onChange={(event) => {
                                  setPrice(event.target.value);
                                }}
                                disabled
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-6"></div>
                          <div className="col-md-6">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Claim Date</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Enter Claim Date"
                                value={processDate}
                                disabled
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-6"></div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Tracking NO.</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Tracking NO."
                                value={trackingCode}
                                onChange={(event) => {
                                  setTrackingCode(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          {/* <div className="col-md-4">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Status</Form.Label>
                              <Form.Select
                                value={status}
                                onChange={(event) => {
                                  setStatus(event.target.value);
                                }}
                              >
                                <option value="1">Pending</option>
                                <option value="2">Delivered</option>
                              </Form.Select>
                            </Form.Group>
                          </div> */}
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Process Date</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Process Date"
                                value={processDate}
                                onChange={(event) => {
                                  setProcessDate(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-8">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Gift Copy :</Form.Label>
                              <Form.Control
                                as="textarea"
                                placeholder="Enter Gift Copy Here"
                                value={giftCopy}
                                onChange={(event) => {
                                  setgiftCopy(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4"></div>

                          <div className="col-md-8">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Terms and Conditions :</Form.Label>
                              <Form.Control
                                as="textarea"
                                placeholder="Enter Terms and Conditions Here"
                                value={termConditions}
                                onChange={(event) => {
                                  setTermConditions(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          // onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Approve
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                  {/* use for view info only */}
                  <>
                    <Modal
                      show={viewShow}
                      onHide={() => {
                        setViewShow(false);
                      }}
                      size="xl"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header
                        closeButton
                        style={{ fontSize: "24px", fontWeight: "bold" }}
                      >
                        Redemption Details
                      </Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Gift Title Name:</th>
                                    <td>{editData?.gift_title}</td>
                                    <th>Tracking No:</th>
                                    <td>{editData?.tracking_number}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.user_id}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData?.transaction_id}</td>
                                  </tr>
                                  <tr>
                                    <th>Saga Price:</th>
                                    <td>${editData?.sagacoin_price}</td>
                                    <th>Processed Date:</th>
                                    <td>
                                      {editData?.processed_date
                                        ? moment
                                            .utc(editData?.processed_date)
                                            .format("YYYY-MM-DD")
                                        : ""}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} className="text-center">
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{ width: "30%", marginTop: "20px" }}
                                onClick={() => {
                                  setViewShow(false);
                                }}
                              >
                                Close
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>

                    <Modal
                      show={checkShow}
                      onHide={() => setCheckShow(false)}
                      // style={{ marginTop: "10%" }}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12} className="text-center">
                              <h2 style={{ fontSize: "24px" }}>
                                <b>Withdrawal Approval</b>
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Gift Title Name:</th>
                                    <td>{editData?.gift_title}</td>
                                    <th>Tracking No:</th>
                                    <td>{editData?.tracking_number}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.user_id}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData?.transaction_id}</td>
                                  </tr>
                                  <tr>
                                    <th>Saga Price:</th>
                                    <td>${editData?.sagacoin_price}</td>
                                    <th>Processed Date:</th>
                                    <td>
                                      {editData?.processed_date
                                        ? moment
                                            .utc(editData?.processed_date)
                                            .format("YYYY-MM-DD")
                                        : ""}
                                    </td>
                                  </tr>
                                  {/* <tr>
                                  <th>Total Deposit:</th>
                                    <td>${editData?.totalDeposit.toFixed(2)}</td>
                                  </tr> */}
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} className="text-center">
                              <p>
                                <b style={{ fontSize: "20px" }}>
                                  Would you like to Approve this transaction?
                                </b>
                              </p>
                              <p style={{ fontSize: "12px" }}>
                                After approval, funds will be sent to the
                                payment provider.
                              </p>
                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{
                                  borderRadius: "8px",
                                  background: "#0A9B14",
                                  border: "none",
                                }}
                                onClick={() => {
                                  approveRedeem();
                                }}
                              >
                                Approve Withdrawal
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>

                    {/* use for cancel only */}
                    <Modal
                      show={cancelShow}
                      onHide={() => setCancelShow(false)}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <Container>
                          <Row>
                            <Col xs={12} className="text-center">
                              <h2 style={{ fontSize: "24px" }}>
                                <b>Redemption Cancellation</b>
                              </h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12}>
                              <table className="table table-striped">
                                <tbody>
                                  <tr>
                                    <th>Gift Title Name:</th>
                                    <td>{editData?.gift_title}</td>
                                    <th>Tracking No:</th>
                                    <td>{editData?.tracking_number}</td>
                                  </tr>
                                  <tr>
                                    <th>Customer ID:</th>
                                    <td>{editData.user_id}</td>
                                    <th>Transaction ID:</th>
                                    <td>{editData?.transaction_id}</td>
                                  </tr>
                                  <tr>
                                    <th>Saga Price:</th>
                                    <td>${editData?.sagacoin_price}</td>
                                    <th>Processed Date:</th>
                                    <td>
                                      {editData?.processed_date
                                        ? moment
                                            .utc(editData?.processed_date)
                                            .format("YYYY-MM-DD")
                                        : ""}
                                    </td>
                                  </tr>
                                  {/* <tr>
                                  <th>Total Deposit:</th>
                                    <td>${editData?.totalDeposit.toFixed(2)}</td>
                                  </tr> */}
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} className="text-center">
                              <p>
                                <b style={{ fontSize: "20px" }}>
                                  Would you like to Cancel this Reedem?
                                </b>
                              </p>

                              <Button
                                variant="primary"
                                size="lg"
                                block
                                style={{
                                  borderRadius: "8px",
                                  background: "#ED0100",
                                  border: "none",
                                }}
                                onClick={() => {
                                  cancelRedeem();
                                  //Cancel(editData);
                                }}
                              >
                                Cancel Request
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Modal.Body>
                    </Modal>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedemDetails;
